import { render } from "./MyTabs.vue?vue&type=template&id=3b8543a2"
import script from "./MyTabs.vue?vue&type=script&lang=js"
export * from "./MyTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__